var _linearGradient, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddCircle28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "add_circle_28-a",
    gradientUnits: "userSpaceOnUse",
    x1: -14,
    x2: 14,
    y1: 14,
    y2: 42
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#498FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#498FF2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14z",
    fill: "url(#add_circle_28-a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7a1 1 0 0 1 1 1v5h5a1 1 0 1 1 0 2h-5v5a1 1 0 1 1-2 0v-5H8a1 1 0 1 1 0-2h5V8a1 1 0 0 1 1-1z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle28);
export default __webpack_public_path__ + "static/media/add_circle_28.f1f28b86.svg";
export { ForwardRef as ReactComponent };